/**
 * @flow
 * @relayHash e06d46aaccd82ac25a37e856502ac313
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteQuotationMutationVariables = {|
  id: string
|};
export type DeleteQuotationMutationResponse = {|
  +deleteQuotation: {|
    +id: string
  |}
|};
export type DeleteQuotationMutation = {|
  variables: DeleteQuotationMutationVariables,
  response: DeleteQuotationMutationResponse,
|};
*/


/*
mutation DeleteQuotationMutation(
  $id: String!
) {
  deleteQuotation(id: $id) {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteQuotation",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "QuotationModel",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeleteQuotationMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "DeleteQuotationMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "DeleteQuotationMutation",
    "id": null,
    "text": "mutation DeleteQuotationMutation(\n  $id: String!\n) {\n  deleteQuotation(id: $id) {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ad7e6802ce2c584f34082e10d4615e39';
module.exports = node;
